module.exports = __webpack_public_path__ + "img/il.71dbb460.svg";